import { useDotLegalBreadCrumbs } from "@dotlegal/dotlegal-ui-components";
import CasePage, { CasePageProps } from "../../core/cases/CasePage";

function Designs(props: CasePageProps) {
    useDotLegalBreadCrumbs([{ name: "Designs" }]);
    return <CasePage {...props} />;
}

export default Designs;
